import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import { EXEMPTION_REASON_OPTIONS } from "../../utils/constants";
import "../css/ExemptionModal.css";

const ExemptionModal = ({ onExempt, onCancel, isLoading }) => {
    const [selectedReason, setSelectedReason] = useState("");

    const handleReasonChange = (reason) => {
        setSelectedReason(reason);
    };

    const handleExempt = () => {
        if (selectedReason) {
            onExempt(selectedReason);
        }
    };

    return (
        <div className="exemption-modal">
            <div className="exemption-modal-header">
                <h2>Do you want to exempt this trip?</h2>
            </div>

            <div className="exemption-modal-body">
                <div className="exemption-note">
                    <span className="exemption-note-text">
                        <strong>Note:</strong> Once you exempt this trip, this action cannot be reverted.
                    </span>
                </div>

                <h3>Select a reason to Exempt</h3>

                <div className="exemption-reasons">
                    {EXEMPTION_REASON_OPTIONS.map((option, index) => (
                        <label key={index} className="exemption-reason-item">
                            <input
                                type="radio"
                                name="exemptionReason"
                                value={option.value}
                                checked={selectedReason === option.value}
                                onChange={() => handleReasonChange(option.value)}
                                className="exemption-radio"
                            />
                            <span className="exemption-reason-text">{option.label}</span>
                        </label>
                    ))}
                </div>
            </div>

            <div className="exemption-modal-actions">
                <button
                    className={`exemption-yes-btn ${!selectedReason ? 'disabled' : ''}`}
                    onClick={handleExempt}
                    disabled={!selectedReason || isLoading}
                >
                    {isLoading ? <CircularProgress size={20} color="inherit" /> : "Yes"}
                </button>
                <button
                    className="exemption-cancel-btn"
                    onClick={onCancel}
                    disabled={isLoading}
                >
                    Cancel
                </button>
            </div>
        </div >
    );
};

export default ExemptionModal;